import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { printPdf } from '../../helper/PrintPdf';
import { showSnackbar } from '../../api/snackbarSlice';
import PrintIcon from '@mui/icons-material/Print';

const documentlActions = {
  '01': 'invoices',
  11: 'invoices',
  '02': 'credit-notes',
  12: 'credit-notes',
  '03': 'debit-notes',
  13: 'debit-notes',
  '04': 'refunds',
  14: 'refunds',
};

const PrintDocument = ({ documentType, documentId }) => {
  documentType = documentlActions[documentType];
  const dispatch = useDispatch();
  const theme = useTheme();
  const pdfTemplates = useSelector((state) => state.pdfTemplates.pdfTemplates);

  const handlePrintPdf = async () => {
    dispatch(showSnackbar({ message: 'Printing document...', severity: 'info' }));

    try {
      const template = pdfTemplates?.find((t) => t.document_type === documentType);

      if (!template) {
        dispatch(showSnackbar({ message: `${documentType} template not found`, severity: 'error' }));
        return;
      }

      await printPdf(documentType, documentId, template);
      dispatch(showSnackbar({ message: 'Document printed successfully!', severity: 'success' }));
    } catch (error) {
      dispatch(showSnackbar({ message: 'Failed to Print Document', severity: 'error' }));
      console.error(error);
    }
  };

  return (
    <Button
      key="print"
      variant="outlined"
      color="primary"
      onClick={handlePrintPdf}
      sx={{ marginLeft: theme.spacing(1) }}
    >
      <PrintIcon fontSize="small" sx={{ mr: 1 }} />
      Print
    </Button>
  );
};

export default PrintDocument;
